import React from 'react';

import countries from "../assets/json/countries.json";

import { Grid, MenuItem, FormControl, FormControlLabel, TextField, Select, Checkbox, Typography, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, FormHelperText } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useSelector } from 'react-redux';
import { selectCalc } from '../redux/calcSlice';

import { useFormik } from 'formik';

import formInitValues from '../assets/json/formInitValues.json';
import shortFields from "../assets/json/shortFields.json";

import ReactHtmlParser from 'react-html-parser';

import axios from "axios";

const ResultsFormDialog = (props) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const calc = useSelector(selectCalc);

  const validate = values => {
    const errors = {};

    for(const key in values) {
      if(key.includes("UTM")) {
        continue;
      }

      if(!values[key]){
        errors[key] = 'Required'
      }else{
        if (key.toLowerCase().includes('email')) {
          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[key])) {
            errors[key] = 'Enter a valid email';
          }
        }
      }
    }

    return errors;
  };

  const urlString =  window.parent.location.search;
  const urlParams = new URLSearchParams(urlString);

  const formik = useFormik({
    initialValues: {
      emailAddress: '',
      company: '',
      country: '',
      marketingpermission: [],
      marketingText: 'Outokumpu can keep me up to date with timely and relevant information. Outokumpu is committed to keeping personal data confidential and secure, and to processing personal data only in accordance with applicable privacy and data protection laws. Please read our <a target="_blank" href="https://www.outokumpu.com/en/privacy-notice">Privacy notice.</a>',
      UTMsource: urlParams.get('utm_source') == null ? '' : urlParams.get('utm_source'),
      UTMmedium: urlParams.get('utm_medium') == null ? '' : urlParams.get('utm_medium'),
      UTMcampaign: urlParams.get('utm_campaign') == null ? '' : urlParams.get('utm_campaign')
    },
    validate,
    onSubmit: async (values) => {
      setLoading(true);
      
      const calcFields = {};

      Object.keys(calc).map(key => {
        if (key in shortFields) {
          calcFields[shortFields[key]] =  Array.isArray(calc[key]) ? calc[key][0]['OKGradeShort'] : calc[key];
        }
      });
      
      const calcString = new URLSearchParams({...calcFields}).toString();

      const now = new Date().toLocaleString();
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      
      const apiResponse = await axios.post("https://en5o2z7yer3vzbj.m.pipedream.net", { ...values, marketingpermission: (values.marketingpermission.length > 0 ? 'on' : ''), calcString, type: 'storage tank calculation', dateTime: `${now} ${timezone}` });

      setLoading(false);
      setSubmitted(true);

      /* eslint-disable */
      if(parent && parent.dataLayer) {
        parent.dataLayer.push({
          'event': 'StorageTankResultsSubmitBtn'
        });
      }
      /* eslint-enable */
    },
  });
  
  return (
    <Dialog 
    maxWidth={'md'} 
    scroll={'paper'}
    PaperProps={{ sx: { m: 0, top: 0, left: 0 } }}
    open={props.open} 
    open={props.open} onClose={props.handleClose}>
      <DialogTitle>
      <IconButton 
        onClick={(e)=> {
          props.handleClose(e);
          setTimeout(() => {
            setSubmitted(false);
          }, 500);
        }}
        style={{ float:'right', margin:'-16px -24px'}} >
            <CloseIcon style={{fontSize:'36px'}}  />
        </IconButton>
        {submitted === true &&
        <React.Fragment>Thank you for your interest in Outokumpu</React.Fragment>}
        {submitted === false &&
        <React.Fragment>Send the results to your emails</React.Fragment>}
      </DialogTitle>

      {submitted === true &&
      <DialogContent>
        <DialogContentText>
          Please check your email for a link to your calculations.
        </DialogContentText>
      </DialogContent>}

      {submitted === false &&
      <DialogContent>
        <DialogContentText>
          Please fill in your details. We will send you an email with a link to your calculations.
        </DialogContentText>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Business Email *
                </Typography>
                <TextField
                  name="emailAddress"
                  type="email"
                  variant="outlined" 
                  inputProps={{ tabIndex: 0 }}
                  onChange={formik.handleChange}
                  value={formik.values.emailAddress}
                  error={formik.touched.emailAddress && formik.errors.emailAddress ? true : false}
                  helperText={formik.touched.emailAddress ? formik.errors.emailAddress : ''}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Company *
                </Typography>
                <TextField
                  name="company"
                  type="text"
                  variant="outlined"
                  inputProps={{ tabIndex: 1 }}
                  onChange={formik.handleChange}
                  value={formik.values.company}
                  error={formik.touched.company && formik.errors.company ? true : false}
                  helperText={formik.touched.company ? formik.errors.company : ''}
                />
              </FormControl>
              <FormControl fullWidth>
                <Typography variant="label" component="label">Your country *</Typography>
                <Select
                  name="country"
                  inputProps={{ tabIndex: 2 }}
                  value={ formik.values.country }
                  renderValue={() => countries.find(country => country.code === formik.values.country) ? countries.find(country => country.code === formik.values.country).name : 'select' }
                  onChange={formik.handleChange}
                  error={formik.touched.country && formik.errors.country ? true : false}
                  IconComponent={KeyboardArrowDownIcon}
                >
                 {countries.map(country => 
                      <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>
                  )}
                </Select>
                {formik.touched.country && formik.errors.country && 
                <FormHelperText>Required</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormControlLabel name="marketingpermission"  labelPlacement={'end'} control={<Checkbox inputProps={{ tabIndex: 3 }} />} onChange={formik.handleChange} label={`${ReactHtmlParser(formik.values.marketingText)}`} />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <LoadingButton 
                  tabIndex={4} 
                  loading={loading} 
                  style={{paddingLeft:'2.6em', margin:0, paddingRight:'2.6em'}} 
                  variant="contained" 
                  type="submit"
                >
                  Submit
                </LoadingButton>
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </DialogContent>}
    </Dialog>
  );
}

export default ResultsFormDialog;